// stores/modal/useModalStore.ts
import { create } from "zustand";
import { devtools } from "zustand/middleware";

export enum Modal {
  Congratulation = "Congratulation",
  AddHorse = "AddHorse",
  EditHorse = "EditHorse",
  DeleteHorse = "DeleteHorse",
  DeleteSaddle = "DeleteSaddle",
  SellSaddleForm = "SellSaddleForm",
  ShoppingCart = "ShoppingCart",
  Upload = "Upload",
  Register = "Register",
  Login = "Login",
  ForgotPassword = "ForgotPassword",
  Event = "Event",
  ComingSoon = "ComingSoon",
  VerifyPhoneCode = "VerifyPhoneCode",
  Profile = "Profile",
  RequestCustomSaddle = "RequestCustomSaddle",
}

interface State {
  current: Modal | null;  
  overlay: Modal | null;   
}

interface Actions {
  open: (m: Modal) => void;
  close: () => void;        
  openOverlay: (m: Modal) => void;   
  closeOverlay: () => void;          
}

export const useModalStore = create<State & Actions>()(
  devtools((set) => ({
    current: null,
    overlay: null,                    

    open: (m) => set({ current: m }), 
    close: () => set({ current: null }),

    openOverlay: (m) => set({ overlay: m }), 
    closeOverlay: () => set({ overlay: null }),
  }))
);
